import { render, staticRenderFns } from "./DashAgendarCafezinho.vue?vue&type=template&id=13bb1bd8"
import script from "./DashAgendarCafezinho.vue?vue&type=script&lang=js"
export * from "./DashAgendarCafezinho.vue?vue&type=script&lang=js"
import style0 from "./DashAgendarCafezinho.vue?vue&type=style&index=0&id=13bb1bd8&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports